import React, {useRef, useState, useEffect} from 'react'
import Sidebar from '../Sidebar'
import { productOptions } from '../Options'
// import env from 'react-dotenv'

export default function BalanceSheetForms() {
    //state definintion
    const [form, setForm] = useState({
        marketingYear:'',
        carryIn: '',
        production:'',
        import:'',
        millConsumption:'',
        export:'',
        carryOut:'',
        commodity:''
    })

    const ref1 = useRef(null)
    const ref2 = useRef(null)
    const ref3 = useRef(null)
    const ref4 = useRef(null)
    const ref5 = useRef(null)
    const ref6 = useRef(null)
    const ref7 = useRef(null)
    const ref8 = useRef(null)

    //year handler
    const yearHandler = (e) =>{
        setForm({...form, marketingYear:e.target.value})
    }

    //caaryIn handler
    const carryInHandler = (e) =>{
        setForm({...form, carryIn:e.target.value})
    }

    //production handler
    const productionHandler = (e) =>{
        setForm({...form, production:e.target.value})
    }

    //import handler
    const importHandler = (e) =>{
        setForm({...form, import: e.target.value})
    }

    //millConsumption
    const millConsumptionHandler = (e) =>{
        setForm({...form, millConsumption: e.target.value})
    }

    //export handler
    const exportHandler = (e) =>{
        setForm({...form, export:e.target.value})
    }

    //carryOut handler
    // const carryOutHandler = (e) =>{
    //     setForm({...form, carryOut:e.target.value})
    // }

    const carry = () =>{
        const x = parseFloat(form.carryIn) + parseFloat(form.production) + parseFloat(form.import)-parseFloat(form.millConsumption) - parseFloat(form.export)
        setForm({...form, carryOut: x})
    }

    const commodityHandler = (e) =>{
        const val = e.target.value.toLowerCase()
        setForm({...form, commodity:val})
    }

    useEffect(()=>{
        carry()
    },[form.carryIn, form.production, form.import, form.millConsumption, form.export])
   
    useEffect(()=>{
       // console.log(form.carryOut)
    },[form.carryOut])

    const reset = ()=>{
        setForm({...form,
        marketingYear:'',
        carryIn: '',
        production:'',
        import:'',
        millConsumption:'',
        export:'',
        carryOut:'',
        commodity:''
        })
        ref1.current.value=''
        ref2.current.value=''
        ref3.current.value=''
        ref4.current.value=''
        ref5.current.value=''
        ref6.current.value=''
        ref7.current.value=''
        ref8.current.value=''
    }

    //submit handler
    const handleSubmit = async(e) =>{
        e.preventDefault()
        const token = sessionStorage.getItem('token')
        const response = await fetch(`${process.env.REACT_APP_API_URL}/create-BS`,{
            method:"POST",
            headers:{
                'Content-Type':'application/json',
                'x-access-token':token
            },
            body:JSON.stringify(form)
        })
        // .then(console.log("Successfully submitted")).then(reset())
    }

  return (
 <>
    <div className="sidebar">
    <Sidebar/>
  </div>
    <div id='tabler'>
      <form onSubmit={handleSubmit}>
<h1>Balance Sheet Form</h1>
<div className="row">

    <div className="col-md-6">
    <label for="formGroupExampleInput" class="form-label">Marketing Year</label>
      {/* <div class="input-group input-group-sm mb-3">
        <input required type="number" min={2000} max={2100} ref={ref1} onChange={yearHandler} class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div> */}
    <select className="form-select" ref={ref1}  id="num-value" onChange={yearHandler} required aria-label="Select example">
                          <option value="">Select year</option>
                          <option value="2025-26">2025-26</option>
                          <option value="2024-25">2024-25</option>
                          <option value="2023-24">2023-24</option>
                          <option value="2022-23">2022-23</option>
                          <option value="2021-22">2021-22</option>
                          <option value="2020-21">2020-21</option>
                          <option value="2019-20">2019-20</option>
                          <option value="2018-19">2018-19</option>
                          <option value="2017-18">2017-18</option>
                          <option value="2016-17">2016-17</option>
                          <option value="2015-16">2015-16</option>
                          <option value="2014-15">2014-15</option>
                          <option value="2013-14">2013-14</option>
                          <option value="2012-13">2012-13</option>
                          <option value="2011-12">2011-12</option>
                          <option value="2010-11">2010-11</option>
                          </select> 
    </div>
    <div className="col-md-6">
    <label for="formGroupExampleInput" class="form-label">Commodity</label>
    <select className="form-select" id="inputGroupSelect04" aria-label="Example select with button addon" onChange={commodityHandler} ref={ref8}required >
          <option value="">Commodity</option>
          {productOptions.map((productOption) => (
            <option key={productOption.value} value={productOption.name}>
              {productOption.text}
            </option>
          ))}
        </select>
    </div>
   
</div>




<div className="row">

    <div className="col-md-6">
    <label for="formGroupExampleInput" class="form-label">Production</label>
    <div class="input-group input-group-sm mb-3">
        <input required type="number" ref={ref3} min={0} onChange={productionHandler} class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
    <div className="col-md-6">
    <label for="formGroupExampleInput" class="form-label">Import</label>
    <div class="input-group input-group-sm mb-3">
        <input required type="number" ref={ref4} min={0} onChange={importHandler} class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
</div>





<div className="row">

    <div className="col-md-6">
    <label for="formGroupExampleInput" class="form-label">Mill Consumption</label>
    <div class="input-group input-group-sm mb-3">
        <input required type="number" ref={ref5}min={0} onChange={millConsumptionHandler} class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
    <div className="col-md-6">
    <label for="formGroupExampleInput" class="form-label">Export</label>
    <div class="input-group input-group-sm mb-3">
        <input required type="number" ref={ref6} min={0} onChange={exportHandler} class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
</div>



<div className="row">



    <div className="col-md-6">
    <label for="formGroupExampleInput" class="form-label">Carry In</label>
    <div class="input-group input-group-sm mb-3">
        <input required type="number" ref={ref2} min={0} onChange={carryInHandler} class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>

    
    <div className="col-md-6">
    <label for="formGroupExampleInput" class="form-label">Carry Out</label>
    <div class="input-group input-group-sm mb-3">
        <input required type="number" ref={ref7} value={form.carryOut} class="form-control" aria-label="Sizing example input" readOnly aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
    
</div>
    
      

    


    

   

 

  

    
    {/* onChange={carryOutHandler} */}
    <button type="submit"  className="btn submit-btn">Submit</button>

      </form>
    </div></>
  )
}
